import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  background-color: #463f3a;
  font-weight: bold;
  border-radius: 0;
`;
